import React, { Component } from 'react';
import Dropdown from './Dropdown';
import Tables from '../Tables';
import FormElement from './FormElement';
import Headers from '../Headers';
import Singleton from '../../sock';
import HotKeyListener from '../../HotKeyListener';
import axios from 'axios';
import url from '../../config/url';
import DisplayError from '../../DisplayError';
import { ToastContainer } from 'react-toastr';
import AsynTypeAheadForTitle from './AsynTypeAheadForTitle';
import DownloadCsv from '../downloadCsv';
const fileHeaders = [
    {
        label: 'Reader Tag', key: 'readerTag'
    },
    {
        label: 'Barcode Tag', key: 'barcodeTag'
    },
    {
        label: 'Message', key: 'message'
    }
];
const mHeaders = ['number', 'barcodeTag', 'message'];//edit it according to json data
var bookno = [],
    barcodeno = [];
const theaders = ['Reader Tag', 'BarCode Tag', 'Message'];
class Catalogue extends Component {
    constructor(props) {
        super(props);
        this.state = {
            tData: {},
            reset: false,
            branch: '',
            title: '',
            bookTypeId: '',
            readerTag: '',
            barcodeTag: '',
            errorVisible: false,
            errorDesc: '',
        }
        this.getId = this.getId.bind(this);
        this.fetchBarcode = this.fetchBarcode.bind(this);
        this.fetchcode = this.fetchcode.bind(this);
        this.clearTable = this.clearTable.bind(this);
        this.handleRefresh = this.handleRefresh.bind(this);
        this.titleSelected = this.titleSelected.bind(this);
        // this.onclickCb = this.onclickCb.bind(this);
    }

    componentWillMount() {
        this.sock = Singleton.getInstance();
    }
    componentDidMount() {
        this.sock.onmessage = (msg) => {
            console.log(msg.data);
            if (typeof (msg.data) === 'string') {
                this.fetchcode(msg.data);
            }
            else {
                FileReader.prototype.that = this;
                var reader = new FileReader();
                reader.onload = function () {
                    console.log(reader.result)

                    reader.__proto__.that.fetchcode(reader.result)
                }
                reader.readAsText(msg.data)

            }
        }
        this.sock.onerror = (err) => {
            console.log(err);
            this.refs.container.error("Could not connect to ThingMagic. Please check your connection and refresh");

        }
    }
    componentWillUnmount() {
        bookno = [];
        Singleton.closeSocket(this.sock);
    }

    clearTable() {
        bookno = [];
        barcodeno = [];
        this.setState({ reset: true });
    }

    handleRefresh() {
        this.setState({ readerTag: '', barcodeTag: '', errorVisible: false })
    }

    getId(value) {
        this.setState({
            branch: value.id
        })
    }

    fetchBarcode(value) {
        this.setState({ barcodeTag: value });
        const { branch, title, readerTag, bookTypeId } = this.state;

        var dataToPost = {
            number: readerTag,
            origLocationBranchId: branch,
            ownerBranchId: branch,
            createdAt: sessionStorage.getItem('at'),
            createdBy: parseInt(sessionStorage.getItem('by')),
            titleId: title,
            bookTypeId: bookTypeId
            // this.state.bookTypeId
        }
        console.log(dataToPost);
        //change reader tag to barcode tag in next line
        console.log(barcodeno);

        if (barcodeno.includes(this.state.readerTag)) {
            console.log('barecode array');
            console.log(barcodeno);
            return;
        }
        else {
            console.log('calling post api');
            axios.post(url + 'insertBook', dataToPost).then(res => {
                console.log(res);
                var { status, successObject } = res.data;
                if (status) {
                    var obj = {};
                    obj.number = this.state.readerTag;
                    obj.barcodeTag = this.state.barcodeTag;
                    obj.message = successObject.msg;
                    console.log(obj);
                    barcodeno.push(this.state.readerTag);

                    this.setState({ tData: obj })
                }
                else {
                    console.log(res.data.errorDescription);
                    this.refs.container.error(res.data.errorDescription)

                    // this.setState({errorVisible:true, errorDesc:})
                }
            }).catch(err => {
                this.refs.container.error('Unable to connect to server')

                console.log(err);
            })


        }

    }

    fetchcode(value) {
        this.setState({
            readerTag: value
        });

        this.fetchBarcode(value)
        // if(bookno.includes(value)){
        //     return;
        // }
        // else{
        //     bookno.push(value);
        //     this.setState({
        //         readerTag:value,
        //     });
        // }

    }

    titleSelected(e) {
        if (e && e.id) {
            this.setState({ title: e.id, bookTypeId: e.bookTypeId })

        }
    }
    render() {
        return (
            <React.Fragment>
                <Headers hname="Magazine Catalogue" />
                <ToastContainer
                    ref="container"
                    className="toast-top-right"
                />
                <DisplayError
                    errorVisible={this.state.errorVisible}
                    errorDesc={this.state.errorDesc}
                />
                <div className="row">
                    <div className="col-lg-4">
                        <Dropdown
                            getId={this.getId}
                        />
                        <AsynTypeAheadForTitle

                            selectedTitle={this.titleSelected}
                        />
                        <FormElement
                            clearTable={this.clearTable}
                            refresh={this.handleRefresh}
                            readerTag={this.state.readerTag}
                            barcodeTag={this.fetchBarcode}
                        />
                    </div>
                    <div className="col-lg-6">
                        <Tables
                            mHeaders={mHeaders}
                            displayCount={this.input}
                            myStyle={{ marginTop: 30 }}
                            headers={theaders}
                            body={this.state.tData}
                            resetTable={this.state.reset}
                        />
                    </div>
                    <div className="col-lg-2" style = {{ marginTop: 30 }}>

                    <DownloadCsv
                            headers={fileHeaders}
                            onclickCb={this.onclickCb}
                            tableId = {"table_"}
                            keys = {["readerTag","barcodeTag","message"]}
                            filename = {`MagazineCatalogue_${new Date().getDate()}-${new Date().getMonth()}.csv`}
                        />
                    </div>
                </div>
            </React.Fragment>
        );
    }
}

export default Catalogue;



// WEBPACK FOOTER //
// ./src/Components/Magazine-Catalogue/Catalogue.js